// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__19nzO","amount":"Amount_amount__2yp1U","tip":"Amount_tip__2VSO2","tipHeader":"Amount_tipHeader__17tga","tipsWrap":"Amount_tipsWrap__EASsh"};